import { useEffect, useState } from 'react';
import { visibility } from '@betgames/bg-tools';

export const usePageVisibility = () => {
    const [isVisible, setIsVisible] = useState(!visibility.isHidden());

    useEffect(() => {
        visibility.setEvent((hidden) => {
            setIsVisible(!hidden);
        });
    }, []);

    return isVisible;
};
